import { Inbox } from "lucide-react";
import type { EmptyStateMessageProps } from "./types";

export const EmptyStateMessage = ({
  message,
  action,
}: EmptyStateMessageProps) => (
  <div className="flex-1 flex flex-col items-center justify-center gap-3 text-gray-400">
    <Inbox className="w-10 h-10 stroke-[1.5]" />
    <p className="text-sm text-center">{message}</p>
    {action}
  </div>
);
